// src/components/SocialLinks.jsx
import React, { useState } from 'react';
import { FaTwitter, FaGlobe, FaEnvelope, FaPhone } from 'react-icons/fa';

const SocialLinks = () => {
  const [showPopup, setShowPopup] = useState('');
  const [popupPosition, setPopupPosition] = useState({ x: 0, y: 0 });

  const handlePopup = (type, e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setPopupPosition({
      x: rect.left + window.scrollX,
      y: rect.bottom + window.scrollY,
    });
    setShowPopup(type);
    setTimeout(() => setShowPopup(''), 2000);
  };

  const socialLinks = [
    {
      icon: <FaTwitter className="w-6 h-6" />,
      url: 'https://x.com/MetaGPT_',
      label: 'Twitter',
    },
    {
      icon: <FaGlobe className="w-6 h-6" />,
      url: 'https://mgx.dev',
      label: 'Website',
    },
    {
      icon: <FaEnvelope className="w-6 h-6" />,
      action: (e) => handlePopup('email', e),
      label: 'Email',
    },
    {
      icon: <FaPhone className="w-6 h-6" />,
      action: (e) => handlePopup('phone', e),
      label: 'Phone',
    },
  ];

  return (
    <div className="flex gap-4 mt-6">
      {socialLinks.map((link, index) => (
        <div key={index} className="relative">
          {link.url ? (
            <a
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-white hover:text-blue-400 transition-colors"
              aria-label={link.label}
            >
              {link.icon}
            </a>
          ) : (
            <button
              onClick={link.action}
              className="text-white hover:text-blue-400 transition-colors"
              aria-label={link.label}
            >
              {link.icon}
            </button>
          )}
        </div>
      ))}
      {showPopup && (
        <div
          className="fixed bg-white text-black px-4 py-2 rounded-md shadow-lg z-50"
          style={{
            left: `${popupPosition.x}px`,
            top: `${popupPosition.y + 10}px`,
          }}
        >
          {showPopup === 'email' ? 'This is a virtual email placeholder' : 'This is a virtual phone placeholder'}
        </div>
      )}
    </div>
  );
};

export default SocialLinks;